var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViewList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 10,
  viewBox: "0 0 12 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M10.998 8C11.544 8 12 8.448 12 9l-.007.117a1 1 0 0 1-.995.883H1.002A1.006 1.006 0 0 1 0 9l.007-.117A1 1 0 0 1 1.002 8Zm0-4C11.544 4 12 4.448 12 5l-.007.117a1 1 0 0 1-.995.883H1.002A1.006 1.006 0 0 1 0 5l.007-.117A1 1 0 0 1 1.002 4Zm0-4C11.544 0 12 .448 12 1l-.007.117a1 1 0 0 1-.995.883H1.002A1.006 1.006 0 0 1 0 1L.007.883A1 1 0 0 1 1.002 0Z"
})));
export default SvgViewList;